import React from "react";
// Material Imports
import makeStyles from "@material-ui/core/styles/makeStyles"; //Limitless imports

import DialogueBody from "../../dialogue-body/DialogueBody";
import ExpertDialogueWrapper from "../expert-dialogue-wrapper/ExpertDialogueWrapper";
import AttachmentBody from "../../attachment-body/AttachmentBody";
import TimePosted from "../../time-posted/TimePosted";
var useStyles = makeStyles({
  dialogueContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  }
});

var ExpertAttachmentDialogue = function ExpertAttachmentDialogue(_ref) {
  var dialogue = _ref.dialogue,
      shouldAnimate = _ref.shouldAnimate,
      isReported = _ref.isReported,
      showExpertThumbnail = _ref.showExpertThumbnail,
      message = _ref.message;
  var classes = useStyles();
  var author = dialogue.author,
      body = dialogue.body,
      created = dialogue.created,
      attachments = dialogue.attachments,
      userId = dialogue.userId;
  var expertInfo = message.expertAuthors[userId];

  if (!showExpertThumbnail && expertInfo) {
    expertInfo.thumbnail = null;
  }

  var hasBody = typeof body === "string";
  return /*#__PURE__*/React.createElement(ExpertDialogueWrapper, {
    shouldAnimate: shouldAnimate,
    author: author,
    expertInfo: expertInfo
  }, function (expertClasses) {
    return /*#__PURE__*/React.createElement("div", {
      className: hasBody ? classes.dialogueContainer : ""
    }, /*#__PURE__*/React.createElement("div", null, attachments && attachments.map(function (attachment, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: index
      }, /*#__PURE__*/React.createElement(AttachmentBody, {
        backgroundStyle: expertClasses.expertBackground,
        textStyling: isReported ? expertClasses.blurText : expertClasses.expertText,
        attachment: attachment
      }));
    })), typeof body === "string" && /*#__PURE__*/React.createElement("div", {
      className: "".concat(expertClasses.listItem, " ").concat(expertClasses.expertBackground)
    }, /*#__PURE__*/React.createElement(DialogueBody, {
      body: body,
      textStyling: isReported ? expertClasses.blurText : expertClasses.expertText,
      linkify: !isReported
    })), created && /*#__PURE__*/React.createElement("div", {
      className: expertClasses.responseTime
    }, /*#__PURE__*/React.createElement(TimePosted, {
      time: created
    })));
  });
};

export default ExpertAttachmentDialogue;
ExpertAttachmentDialogue.defaultProps = {
  isReported: false,
  showExpertThumbnail: true
};